// Updated App.js - Main Router Component
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { updateLastActive } from './utils/auth';

// Layout
import Layout from './components/Layout';

// Pages
import CategoryExplorer from './pages/CategoryExplorer';
import CategoryAlert from './pages/CategoryAlert';
import SemanticSearch from './pages/SemanticSearch';
import Dashboard from './pages/Dashboard';
import AlertPage from './pages/AlertPage';
import Companies from './pages/Companies';
import Login from './pages/Login';
import CategoryPage from './pages/CategoryPage';
import GrievanceModalDemo from './components/Modal';
import FeedbackPage from './pages/FeedbackPage';
import ProtectedRoute from './ProtectedRoute';
import ComplaintsTable from './components/ComplaintsTable';

const theme = createTheme({
    palette: {
        primary: {
            main: '#3B32CB',
        },
        secondary: {
            main: '#dc004e',
        },
        background: {
            default: '#ECEAFC',
        },
    },

    typography: {
        fontFamily: `'Helvetica Neue', Helvetica, Arial, sans-serif`,
        h4: { fontWeight: 600 },
        h5: { fontWeight: 600 },
        h6: { fontWeight: 600 },
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontFamily: `'Helvetica Neue', Helvetica, Arial, sans-serif`,
                },
            },
        },

        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: `'Helvetica Neue', Helvetica, Arial, sans-serif`,
                },
            },
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: `'Helvetica Neue', Helvetica, Arial, sans-serif`,
                    textTransform: 'none',
                },
            },
        },

        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    borderRadius: '8px',
                },
            },
        },

        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    borderRadius: '8px',
                },
            },
        },
    },
});


function AppContent() {
    const location = useLocation();
    const isLoginPage = location.pathname === '/';

    if (isLoginPage) {
        return
        <Login />
    }

    return (
        <Layout>
            <Routes>
                {/* Main Pages */}

                <Route path="/dashboard" element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                } />
                <Route path="/category-explorer" element={
                    <ProtectedRoute>
                        <CategoryExplorer />
                    </ProtectedRoute>
                } />
                <Route path="/category-alert" element={
                    <ProtectedRoute>
                        <CategoryAlert />
                    </ProtectedRoute>
                } />
                <Route path="/semantic-search" element={
                    <ProtectedRoute>
                        <SemanticSearch />
                    </ProtectedRoute>
                } />
                <Route path="/alert" element={
                    <ProtectedRoute>
                        <AlertPage />
                    </ProtectedRoute>
                } />
                <Route path="/companies" element={
                    <ProtectedRoute>
                        <Companies />
                    </ProtectedRoute>
                } />
                <Route path='/categories' element={
                    <ProtectedRoute>
                        <CategoryPage />
                    </ProtectedRoute>
                } />
                <Route path="/modal" element={
                    <ProtectedRoute>
                        <GrievanceModalDemo />
                    </ProtectedRoute>
                } />
                <Route path='/feedback' element={
                    <ProtectedRoute>
                        <FeedbackPage />
                    </ProtectedRoute>
                } />
                <Route path="/complaints" element={
                    <ProtectedRoute>
                        <CategoryExplorer />
                    </ProtectedRoute>
                } />

                {/* Catch all route - redirect to dashboard */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
        </Layout>
    );
}



function App() {
    React.useEffect(() => {
        const handleActivity = () => {
            updateLastActive();
        };

        window.addEventListener('mousemove', handleActivity);
        window.addEventListener('keydown', handleActivity);
        window.addEventListener('click', handleActivity);
        window.addEventListener('scroll', handleActivity);

        return () => {
            window.removeEventListener('mousemove', handleActivity);
            window.removeEventListener('keydown', handleActivity);
            window.removeEventListener('click', handleActivity);
            window.removeEventListener('scroll', handleActivity);
        };
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/*" element={<AppContent />} />
            </Routes>
        </ThemeProvider>
    );
}

export default App;